export enum NavModes {
  REDIRECT = 'redirect',
  DROPDOWN = 'navDropdown',
  OUTLINED = 'outlined-button',
  FILLED = 'filled-button',
}

export enum DropDownTypes {
  FullWidth = 'fullWidth',
  ContentWidth = 'contentWidth',
}

export enum MobileCategoryTypes {
  LINK = 'link',
  ACCORDION = 'accordion',
  MIXED = 'mixed',
}
